<template>
  <button
    :type="type"
    class="
     
    "
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "submit",
    },
  },
};
</script>

<style lang="sass" scoped>
button
  background-color: #333
  border-radius: 4px
  padding: 10px 20px
  color: #fff
</style>